(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('ser-recently-viewed')) {
    customElements.define('ser-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const key = 'ser_recently_viewed_v1';
        const current = this.dataset.handle;
        const now = Date.now();
        let history = [];
        try {
          const saved = JSON.parse(localStorage.getItem(key) || '[]');
          if (Array.isArray(saved)) history = saved.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && now - item.time < 2592000000);
        } catch {}
        const seen = new Set();
        history = history.filter(item => item.handle !== current && !seen.has(item.handle) && seen.add(item.handle));
        try { if (current) localStorage.setItem(key, JSON.stringify([{handle: current, time: now}, ...history].slice(0, 20))); } catch {}
        if (!history.length) return;
        this.loadCards(history.slice(0, 6));
      }
      async loadCards(history) {
        const root = this.dataset.root.replace(/\/?$/, '/');
        const cards = await Promise.all(history.map(async item => {
          try {
            const response = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '?section_id=section-rendering-product-card');
            if (!response.ok) return null;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const template = html.querySelector('template[data-recently-viewed-card]');
            const card = template?.content.querySelector('.recently-viewed__item');
            return card ? document.importNode(card, true) : null;
          } catch { return null; }
        }));
        const valid = cards.filter(Boolean);
        if (!valid.length || !this.isConnected) return;
        const heading = document.createElement('h2');
        heading.className = 'recently-viewed__heading';
        heading.textContent = this.dataset.heading;
        const list = document.createElement('ul');
        list.className = 'recently-viewed__list';
        list.setAttribute('role', 'list');
        list.append(...valid);
        this.replaceChildren(heading, list);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
